var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewFile',{attrs:{"boxHeight":_vm.boxHeight,"multiple":true,"message":"Drop files or click to browse","fileName":false,"basePath":_vm.basePath},on:{"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }